import { Store } from "bernie-plugin-mobx";
import { SerializedData } from "bernie-core";
import { NOOP_LOGGER } from "bernie-logger";
import { FlexBffResponse, UriContext } from "src/typings/flexFramework/FlexDefinitions";

export class UriContextStore extends Store {
  private uriContext?: UriContext;

  public constructor(state: SerializedData = {}) {
    super(state, NOOP_LOGGER);
  }

  public setup(res?: FlexBffResponse): void {
    if (!res || !res.uriContext) return;

    this.uriContext = res.uriContext;
  }

  public get(): UriContext | undefined {
    return this.uriContext;
  }

  public hydrate(data: SerializedData = {}) {
    Object.assign(this, data);
  }

  public toJSON(): SerializedData {
    return {
      uriContext: this.uriContext,
    };
  }
}

export default UriContextStore;
